import { Injectable } from '@angular/core';

export const SESSION_KEEP_KEYS = [
  'sId',
  'bId',
  'repId',
  'storeList',
  'merchants',
  'countryList',
  'enableHomeStoreSelection',
  'enableStoreStaffSelection',
  'enableSourceSelection',
  'enableAmountInput',
  'showGiftVoucherFlow',
  'selectedHomeSchemeId',
  'giftVoucherCode',
  'giftCampaignId',
];

export function clearLocalStorageExcept(exceptions: string[] = []) {
  const keysToKeep = new Set(
    [
      ...exceptions,
      'sId',
      'storeName',
      'storeList',
      'merchants',
      'countryList',
      'enableHomeStoreSelection',
      'enableStoreStaffSelection',
      'enableSourceSelection',
      'enableAmountInput',
      'showGiftVoucherFlow',
      'selectedHomeSchemeId',
      'giftVoucherCode',
      'giftCampaignId',
    ].map((k) => k.toLowerCase())
  );

  Object.keys(localStorage).forEach((key) => {
    if (!keysToKeep.has(key.toLowerCase())) {
      localStorage.removeItem(key);
    }
  });
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private redirecting = false;

  hasSession(): boolean {
    return !!(localStorage.getItem('token') || localStorage.getItem('tempTerminal'));
  }

  isPublicPath(pathname: string = window.location.pathname): boolean {
    const path = pathname.replace(/\/+$/, '') || '/';
    return path === '/' || path.includes('payment-success') || path.startsWith('/staff');
  }

  getLoginUrl(): string {
    const params = new URLSearchParams();
    const repId = localStorage.getItem('repId');
    const redirectTo = localStorage.getItem('redirectTo');
    if (repId) {
      params.set('sId', repId);
    }
    if (redirectTo) {
      params.set('redirectTo', redirectTo);
    }
    const query = params.toString();
    return query ? `${window.location.origin}/?${query}` : `${window.location.origin}/`;
  }

  clearSession(extraKeep: string[] = []): void {
    clearLocalStorageExcept([...SESSION_KEEP_KEYS, ...extraKeep]);
  }

  redirectToLogin(options: { clear?: boolean; extraKeep?: string[] } = {}): void {
    if (this.redirecting) {
      return;
    }
    this.redirecting = true;

    if (options.clear !== false) {
      this.clearSession(options.extraKeep);
    }

    window.location.replace(this.getLoginUrl());
  }

  /**
   * If the current page requires a session and none exists (DevTools clear,
   * PWA auto-logout, expired token), force a full reload to the login screen.
   */
  ensureAuthenticated(): boolean {
    if (this.hasSession() || this.isPublicPath()) {
      return true;
    }
    this.redirectToLogin();
    return false;
  }
}
